import { EmailTextColorEnum, EmailTextFontEnum, EmailTextSizeEnum } from '@/types/generated'

export const EDITOR_COLORS = Object.values(EmailTextColorEnum).map((value) => value)
export const EDITOR_TEXT_SIZES = Object.values(EmailTextSizeEnum).map((value) => value)
export const EDITOR_FONT_FAMILIES = {}
EDITOR_FONT_FAMILIES[EmailTextFontEnum.ARIAL_HELVETICA_SANS_SERIF as string] = 'Arial'
EDITOR_FONT_FAMILIES[EmailTextFontEnum.GEORGIA_SERIF as string] = 'Georgia'
EDITOR_FONT_FAMILIES[EmailTextFontEnum.IMPACT_CHARCOAL_SANS_SERIF as string] = 'Impact'
EDITOR_FONT_FAMILIES[EmailTextFontEnum.TAHOMA_GENEVA_SANS_SERIF as string] = 'Tahoma'
EDITOR_FONT_FAMILIES[EmailTextFontEnum._TIMES_NEW_ROMAN__TIMES_SERIF as string] = 'Times New Roman'
EDITOR_FONT_FAMILIES[EmailTextFontEnum.VERDANA_GENEVA_SANS_SERIF as string] = 'Verdana'
